import { getStorage, removeStorage } from '@utils/localStorage';

function getThisWindow() {
    // @ts-ignore
    if (window.topWindow) {
        return window;
    } else {
        return parent;
    }
}

const go = (url: string) => {
    const thisWindow = getThisWindow();
    const oriHash = thisWindow.location.hash.substr(1);
    const newHash = url;
    thisWindow.location.hash = url;
    if (newHash === oriHash) {
        const noJump = getStorage('nojump');
        removeStorage('nojump');
        if (noJump !== 'true') {
            thisWindow.location.reload();
        }
    }
};

export default { go, getThisWindow };
